import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { userService } from '../../application/user';
import Button from '../../components/common/button';
import LoadingSpinner from '../../components/common/loadingSpinner';
import FormContainer from '../../components/forms/formContainer';
import Layout from '../../components/layout/layout';
import { homepageRoute } from '../../domain/websiteDomain';
import useUserWithRedirects from '../../hooks/useUser';

interface VerifyEmailProps {}

type Status = 'loading' | 'success' | 'error';

const VerifyEmail: React.FC<VerifyEmailProps> = () => {
  const user = useUserWithRedirects();
  const router = useRouter();
  const [status, setStatus] = useState<Status>('loading');

  useEffect(() => {
    const applicationUser = userService();

    const verifyEmail = async () => {
      const { token } = router.query;

      if (token) {
        try {
          await applicationUser.verifyUser(token as string, user);
          setStatus('success');
        } catch (err) {
          setStatus('error');
        }
      }
    };

    verifyEmail();
  }, [router.query]);

  return (
    <Layout classes="bg-background-lighter" title="Email Verification">
      {status === 'loading' && (
        <FormContainer title="Verifying...">
          <div className="text-center">
            <LoadingSpinner />
          </div>
        </FormContainer>
      )}

      {status === 'success' && (
        <FormContainer title="Success!">
          <div className="mb-6" data-cy="message-container">
            Thank you, your email is now verified. See you on the mat!
          </div>
          <Button buttonStyle="primary" href={homepageRoute}>
            Get Started
          </Button>
        </FormContainer>
      )}

      {status === 'error' && (
        <FormContainer title="Oh, there appears to be an issue...">
          <div className="mb-6" data-cy="message-container">
            {`Your email was not able to be verified. Please contact support and
            we'll take a closer look`}
          </div>
        </FormContainer>
      )}
    </Layout>
  );
};

export default VerifyEmail;
